import React from "react";
import AddProduccionHuevosForm from "../../../Granja/Add/Forms/AddProduccionHuevosForm/AddProduccionHuevosForm";
import ProduccionHuevosTable from "./ProduccionHuevosTable/ProduccionHuevosTable";
import { useShoppingContext } from "../../../context/ShoppingContext";

const Produccion = () => {
  const { showAddProduccion } = useShoppingContext();

  return (
    <div className="content-container">
      <div className="section">
        {showAddProduccion && (
          <div className="form-container">
            <AddProduccionHuevosForm />
          </div>
        )}
        <div className="table-container">
          <ProduccionHuevosTable />
        </div>
      </div>
    </div>
  );
};

export default Produccion;
